import {INCREMENT_STEP, DECREMENT_STEP, APRON_DEACTIVATE, TILE_FALNGES_DEACTIVATE} from "../actions/types";
import {BATHTUBE_STEPS_NO_FLANGES, DWDF_STEPS_NO_APRON} from "../constants/steps";

function calculateStep ({noSZ,noZ, step, direction}){
    if(noSZ) {
        const computedStep = step === 4 ?
            direction === 'prev' ? 3 : 5
            : step;

        return computedStep
    }

    if(noZ){
        const computedStep = step === 2 ?
            direction === 'prev' ? 1 : 3
            : step;

        return computedStep
    }

    return step
}



export default (state = {currentStep: 1, numberOfSteps: 10, direction: '', allSteps: false}, action) => {
    switch (action.type) {
        case INCREMENT_STEP:
            if (state.currentStep < state.numberOfSteps) {
                return {
                    ...state,
                    currentStep: calculateStep({noSZ: state.apron, noZ: state.flanges ,step: state.currentStep + 1, direction: "next"}),
                    direction: 'next',
                }
            } else {
                return state;
            }
        case DECREMENT_STEP:
            if (state.currentStep > 1) {
                return {
                    ...state,
                    currentStep: calculateStep({noSZ: state.apron, noZ: state.flanges ,step: state.currentStep - 1, direction: "prev"}),
                    direction: 'prev'
                }
            } else {
                return state;
            }
        case APRON_DEACTIVATE:
            return {
                ...state,
                apron: true,
                allSteps: DWDF_STEPS_NO_APRON,
            }
        case TILE_FALNGES_DEACTIVATE:
            return {
                ...state,
                flanges: true,
                allSteps: BATHTUBE_STEPS_NO_FLANGES,
            }
        default:
            return state;

}
}



// WEBPACK FOOTER //
// ./src/reducers/stepsReducer.js